class AdpSimpleTableController {
  constructor() {
    this.name = 'adpSimpleTable';
  }
}

export default AdpSimpleTableController;



// WEBPACK FOOTER //
// ./src/app/components/adpSimpleTable/adpSimpleTable.controller.js